"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _PayUIcons = _interopRequireDefault(require("../PayUIcons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var type = _ref.type,
      children = _ref.children,
      classNameProp = _ref.className,
      variant = _ref.variant,
      loading = _ref.loading,
      startIcon = _ref.startIcon,
      endIcon = _ref.endIcon,
      rest = _objectWithoutProperties(_ref, ["type", "children", "className", "variant", "loading", "startIcon", "endIcon"]);

  var className = (0, _clsx["default"])('od-button', {
    'outlined': variant == 'outlined',
    'outlined-muted': variant == 'outlined-muted',
    'underlined': variant == 'underlined',
    'loading': loading,
    'start-icon': !!startIcon.type,
    'end-icon': !!endIcon.type
  }, classNameProp);
  var classNameLoader = (0, _clsx["default"])('co-btn-loader', {
    'outlined': variant == 'outlined',
    'outlined-muted': variant == 'outlined-muted',
    'underlined': variant == 'underlined'
  });
  return _react["default"].createElement("button", _extends({
    type: type,
    className: className
  }, rest), startIcon && startIcon.type && _react["default"].createElement(_PayUIcons["default"], {
    type: startIcon.type,
    size: startIcon.size,
    color: startIcon.color
  }), children, loading && _react["default"].createElement("span", {
    className: classNameLoader
  }), endIcon && endIcon.type && _react["default"].createElement(_PayUIcons["default"], {
    type: endIcon.type,
    size: endIcon.size,
    color: endIcon.color
  }));
};

Button.propTypes = {
  type: _propTypes["default"].string,
  children: _propTypes["default"].node,
  variant: _propTypes["default"].oneOf(['default', 'outlined', 'underlined', 'outlined-muted']),
  loading: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
Button.defaultProps = {
  type: '',
  children: '',
  variant: 'default',
  loading: false,
  className: '',
  startIcon: {
    type: null,
    size: '12px',
    color: 'white'
  },
  endIcon: {
    type: null,
    size: '12px',
    color: 'white'
  }
};
var _default = Button;
exports["default"] = _default;